import styled from 'styled-components';
import { theme } from '@/styles/theme';
import { Container, Section, Grid } from '@/components/ui/Container';
import { Card, CardContent, CardTitle, CardFooter } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';
import { FadeInWhenVisible } from '@/components/animations/FadeInWhenVisible';
import { Calendar, MapPin, Clock } from 'lucide-react';

const PageHeader = styled(Section)`
  background: ${theme.colors.primary.navy};
  color: ${theme.colors.neutral.white};
  text-align: center;
  padding: ${theme.spacing[24]} 0 ${theme.spacing[16]};
`;

const PageTitle = styled.h1`
  color: ${theme.colors.neutral.white};
  margin-bottom: ${theme.spacing[4]};
`;

const EventCard = styled(Card)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const EventImage = styled.div`
  width: 100%;
  height: 200px;
  background: linear-gradient(135deg, ${theme.colors.secondary.ivory}, ${theme.colors.secondary.cream});
  border-radius: ${theme.borderRadius.lg};
  margin-bottom: ${theme.spacing[4]};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.neutral.gray};
`;

const EventInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing[2]};
  color: ${theme.colors.neutral.gray};
  font-size: ${theme.fontSizes.sm};
  margin-bottom: ${theme.spacing[2]};

  svg {
    color: ${theme.colors.primary.royalBlue};
  }
`;

const EventDescription = styled.p`
  color: ${theme.colors.neutral.gray};
  line-height: ${theme.lineHeights.relaxed};
  margin: ${theme.spacing[3]} 0;
  flex-grow: 1;
`;

export const ConcertsPage = () => {
  const upcomingEvents = [
    {
      id: 1,
      title: 'Nieuwjaarsconcert 2026',
      date: '12 januari 2026',
      time: '20:00',
      location: 'Cultureel Centrum Poperinge',
      description: 'Start het nieuwe jaar met ons traditionele nieuwjaarsconcert vol feestelijke muziek.',
    },
    {
      id: 2,
      title: 'Voorjaarsconcert',
      date: '23 maart 2026',
      time: '15:00',
      location: 'Sint-Bertinuskerk',
      description: 'Een gevarieerd programma met klassieke en moderne werken.',
    },
    {
      id: 3,
      title: 'Openluchtconcert',
      date: '15 juni 2026',
      time: '19:00',
      location: 'Grote Markt Poperinge',
      description: 'Geniet van een zomeravond vol muziek op de Grote Markt.',
    },
  ];

  return (
    <>
      <PageHeader>
        <Container>
          <FadeInWhenVisible>
            <PageTitle>Evenementen & Concerten</PageTitle>
          </FadeInWhenVisible>
        </Container>
      </PageHeader>

      <Section>
        <Container>
          <FadeInWhenVisible>
            <h2 style={{ marginBottom: theme.spacing[8] }}>Aankomende Evenementen</h2>
          </FadeInWhenVisible>

          <Grid columns={3}>
            {upcomingEvents.map((event, index) => (
              <FadeInWhenVisible key={event.id} delay={index * 0.1}>
                <EventCard elevated>
                  <EventImage>[Event Foto]</EventImage>
                  <CardContent>
                    <CardTitle>{event.title}</CardTitle>
                    <EventInfo>
                      <Calendar size={16} />
                      <span>{event.date}</span>
                    </EventInfo>
                    <EventInfo>
                      <Clock size={16} />
                      <span>{event.time}</span>
                    </EventInfo>
                    <EventInfo>
                      <MapPin size={16} />
                      <span>{event.location}</span>
                    </EventInfo>
                    <EventDescription>{event.description}</EventDescription>
                  </CardContent>
                  <CardFooter>
                    <Button fullWidth variant="primary">Meer Info</Button>
                  </CardFooter>
                </EventCard>
              </FadeInWhenVisible>
            ))}
          </Grid>
        </Container>
      </Section>
    </>
  );
};
